import gradesApi from '../../../services/plataforma/grades';

export default {
  getCourseGradesContext(_, courseId) {
    return gradesApi.getCourseGradesContext(courseId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getGradeCategoryById(_, { courseId, categoryId }) {
    return gradesApi.getGradeCategoryById(courseId, categoryId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  createGradeCategory({ commit }, { courseId, categoryData }) {
    return gradesApi.createGradeCategory(courseId, categoryData)
      .then(response => {
        commit('CREATE_CATEGORY', response.data);
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response));
  },
  editGradeCategory(_, { courseId, categoryData }) {
    return gradesApi.editGradeCategory(courseId, categoryData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  deleteGradeCategory(_, { courseId, categoryData }) {
    return gradesApi.deleteGradeCategory(courseId, categoryData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getGradeCategories({ commit }, { courseId, variablesOrigin }) {
    return gradesApi.getGradeCategories({ courseId, variablesOrigin })
      .then(response => {
        commit('SET_CATEGORIES', response.data);
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response));
  },
  createGradeBook(_, { courseId, categoryId, gradeBookData }) {
    return gradesApi.createGradeBook(courseId, categoryId, gradeBookData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editGradeBook(_, { courseId, categoryId, gradeBookData }) {
    return gradesApi.editGradeBook(courseId, categoryId, gradeBookData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  deleteGradeBook(_, { courseId, categoryId, gradeBookData }) {
    return gradesApi.deleteGradeBook(courseId, categoryId, gradeBookData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getGradeBooks(_, { courseId, categoryId }) {
    return gradesApi.getGradeBooks({ courseId, categoryId })
      .then(response => Promise.resolve(response.data.gradeBooks))
      .catch(e => Promise.reject(e.response));
  },
  getGradeBookDetails(_, { courseId, categoryId, bookId, isActive }) {
    return gradesApi.getGradeBookDetails({ courseId, categoryId, bookId, isActive })
      .then(response => Promise.resolve(response.data.gradeBookDetails))
      .catch(e => Promise.reject(e.response));
  },
  getStudentsGradeBook(_, { courseId, categoryId, name, limit, offset }) {
    return gradesApi.getStudentsGradeBook({ courseId, categoryId, name, limit, offset })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getStudentsGradeBookDetails(_, { courseId, categoryId, bookId, name, limit, offset }) {
    return gradesApi.getStudentsGradeBookDetails({ courseId, categoryId, bookId, name, limit, offset })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchGradeBook(_, { courseId, categoryId, bookId, body }) {
    return gradesApi.patchGradeBook({ courseId, categoryId, bookId, body })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  patchGradeBookDetail(_, { courseId, categoryId, bookId, detailId, body }) {
    return gradesApi.patchGradeBookDetail({ courseId, categoryId, bookId, detailId, body })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editGradeBookStudentValue(_, { courseId, categoryId, bookId, enrollmentId, editedValue }) {
    return gradesApi.editGradeBookItem(courseId, categoryId, bookId, enrollmentId, { editedValue })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editGradeDetailStudentValue(_, { courseId, categoryId, bookId, detailId, enrollmentId, editedValue }) {
    return gradesApi.editGradeBookDetailItem(courseId, categoryId, bookId, detailId, enrollmentId, { editedValue })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editAverageGrade(_, { courseId, categoryId, enrollmentId, editedValue }) {
    return gradesApi.editStudentAverge(courseId, categoryId, enrollmentId, { editedValue })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  editFinalGrade(_, { courseId, enrollmentId, editedValue }) {
    return gradesApi.editStudentFinal(courseId, enrollmentId, { editedValue })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getStudentGradesByCourseId(_, courseId) {
    return gradesApi.getStudentGradesByCourseId(courseId)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  actionSubmitCorrection(_, { courseId, correctionId, data }) {
    return gradesApi.submitCorrection(courseId, correctionId, data)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionSubmitCorrectionWithoutCorrectionId(_, { courseId, data }) {
    return gradesApi.submitCorrectionWithoutCorrectionId(courseId, data)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionChangeSequenceOfCategory(_, params) {
    return gradesApi.changeSequenceOfCategory(params)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionGetGradeItems(_, params) {
    return gradesApi.getGradeItems(params)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((err) => {
        return Promise.reject(err.response.data.error.message);
      });
  },
  actionPostH5PXAPIEvent(_, { statement, topicId, academicMainId }) {
    return gradesApi.postH5PXAPIEvent({ body: { statement }, topicId, academicMainId });
  }
};
